export default __webpack_public_path__ + "static/media/Telecommuting-rafiki.40a62f37.png";